<div class="container" fxLayout="row wrap">
  <label class="heading">Contests</label><br>
    <p class="heading2">
    Ready to enter some exciting contests? Click one of the images below for
    more information and to begin.
    </p>
</div>

<!-- <div class="container">
    <div class="row">
      <div class="col custom-column" *ngFor="let item of imageData">
        <img [src]="item.imageUrl">
        <label>{{ item.category }}</label><br>
        <span>{{ item.status }}</span>
      </div>
 
      <div class="col custom-column" *ngFor="let item of imageData2">
        <img [src]="item.imageUrl">
        <label>{{ item.category }}</label><br>
        <span>{{ item.status }}</span>
      </div>


      <div class="col custom-column" *ngFor="let item of imageData3">
        <img [src]="item.imageUrl">
        <label>{{ item.category }}</label><br>
        <span>{{ item.status }}</span>
      </div>
  </div>
</div> -->

<!-- -----------------------------------------------------------------------------------chatgpt -->
<!-- <div class="container">
  <div class="row">
    <div class="col-md-4" *ngFor="let data of imageData">
      <div class="custom-column">
        <img src="{{data.imageUrl}}" alt="Image 1" class="img-fluid">
        <div class="overlay">
          <label>{{data.category}}</label><br>
          <span>{{data.status}}</span>
        </div>
      </div>
    </div>

    <div class="col-md-4" *ngFor="let data of imageData2">
      <div class="custom-column">
        <img src="{{data.imageUrl}}" alt="Image 2" class="img-fluid">
        <div class="overlay">
          <label>{{data.category}}</label><br>
          <span>{{data.status}}</span>
        </div>
      </div>
    </div>
   
    <div class="col-md-4" *ngFor="let data of imageData3">
      <div class="custom-column">
        <img src="{{data.imageUrl}}" alt="Image 3" class="img-fluid">
        <div class="overlay">
          <label>{{data.category}}</label><br>
          <span>{{data.status}}</span>
        </div>
      </div>
    </div>
    </div>
</div> -->
<!-- -------------------------------------------------------------------------------my code------------------- -->
<div class="container">
  <div class="row">
<div class="col align-self-start custom-column">
        <img class="img" class="film" (click)="filmPage()" src="../../../../../../assets/images/contest/all-contest/film_jlaw2.jpg">
        <label class="film" (click)="filmPage()">FILM</label><br>
        <span id="live" class="film" (click)="filmPage()">NOW LIVE</span>
        <img class="img4" src="../../../../../../assets/images/contest/all-contest/spainwirelessshow2.jpg">
        <label id="img4">VIRTUAL REALITY</label><br>
        <span id="virtual">COMING SOON</span>
        <img class="img8" src="../../../../../../assets/images/contest/all-contest/9357666_orig.jpg">
        <label id="img8">MUSIC</label><br>
        <span id="music">COMING SOON</span>
      </div>
      <div class="col align-self-center custom-column">
        <img class="img1" src="../../../../../../assets/images/contest/all-contest/contest-book12.jpg">
        <label id="img1">BOOKS|STORY TELLING</label><br>
        <span id="books">COMING SOON</span>
        <img class="img2" src="../../../../../../assets/images/contest/all-contest/contest-art.jpg">
        <label>ART + DESIGN</label><br>
        <span>COMING SOON</span>
        <img class="img7" src="../../../../../../assets/images/contest/all-contest/lt-sub-sharing_mainop1_madisonlarae_t1070_h08f26e91b3782cc03ee668f515e622f4e84c7f95.jpg">
        <label id="img7">FASHION</label><br>
        <span id="fashion">COMING SOON</span>
    </div>
      <div class="col align-self-end custom-column">
        <img class="img3" src="../../../../../../assets/images/contest/all-contest/contest-tech.jpg">
        <label>TECH + SCIENCE</label><br>
        <span>COMING SOON</span>
        <img class="img5" src="../../../../../../assets/images/contest/all-contest/hulu-plus-high-tech-ways-to-watch-tv2.jpg">
        <label id="img5">TELEVISION</label><br>
        <span id="television">COMING SOON</span>
        <img class="img6" src="../../../../../../assets/images/contest/all-contest/hip-hop-dance-lessons-teens.jpg">
        <label id="img6">DANCE</label><br>
        <span id="dance" >COMING SOON</span>
    </div>

  </div>
</div>
  <!-- ------------------------------------------------------------------------my code-------------------------- -->
   <!-- <div>
      <div class="col custom-column" *ngFor="let img of imageData">
        <img src="{{img.imageUrl}}">
        <label>{{img.category}}</label>
        <span>{{img.status}}</span>
      </div>
      <div class="col align-self-center custom-column" *ngFor="let img of imageData">
        <img src="{{img.imageUrl}}">
        <label>{{img.category}}</label>
        <span>{{img.status}}</span>
      </div>
      <div class="col align-self-end custom-column" *ngFor="let img of imageData">
        <img src="{{img.imageUrl}}">
        <label>{{img.category}}</label>
        <span>{{img.status}}</span>
      </div>
    </div> -->